export const fomo: {
  names: Record<string, string[]>;
  cities: Record<string, string[]>;
} = {
  names: {
    AL: [
      'Arber',
      'Ariana',
      'Blerim',
      'Elona',
      'Arjan',
      'Mirela',
      'Endrit',
      'Erinda',
      'Eri',
      'Blerta',
    ],
    US: [
      'Liam',
      'Olivia',
      'Noah',
      'Emma',
      'Oliver',
      'Ava',
      'Elijah',
      'Charlotte',
      'William',
      'Sophia',
    ],
    AD: [
      'Marc',
      'Aina',
      'Jordi',
      'Laura',
      'Eric',
      'Maria',
      'David',
      'Anna',
      'Pau',
      'Sofia',
    ],
    AT: [
      'Lukas',
      'Emma',
      'David',
      'Anna',
      'Maximilian',
      'Sophia',
      'Elias',
      'Mia',
      'Leon',
      'Emilia',
    ],
    BE: [
      'Liam',
      'Emma',
      'Noah',
      'Olivia',
      'Lucas',
      'Louise',
      'Adam',
      'Alice',
      'Louis',
      'Mila',
    ],
    BA: [
      'Tarik',
      'Amina',
      'Adin',
      'Lejla',
      'Harun',
      'Emina',
      'Amir',
      'Sara',
      'Armin',
      'Lana',
    ],
    BG: [
      'Georgi',
      'Maria',
      'Ivan',
      'Viktoria',
      'Nikolay',
      'Nikol',
      'Dimitar',
      'Elena',
      'Martin',
      'Gabriela',
    ],
    HR: [
      'Luka',
      'Lucija',
      'David',
      'Mia',
      'Ivan',
      'Ema',
      'Marko',
      'Sara',
      'Josip',
      'Nika',
    ],
    CY: [
      'Andreas',
      'Maria',
      'Georgios',
      'Elena',
      'Nicolas',
      'Anna',
      'Christos',
      'Sophia',
      'Panagiotis',
      'Eleni',
    ],
    CZ: [
      'Jakub',
      'Eliška',
      'Jan',
      'Tereza',
      'Adam',
      'Anna',
      'Tomáš',
      'Lucie',
      'Matěj',
      'Adéla',
    ],
    DK: [
      'William',
      'Emma',
      'Noah',
      'Freja',
      'Lucas',
      'Ida',
      'Oscar',
      'Clara',
      'Malthe',
      'Sofia',
    ],
    EE: [
      'Rasmus',
      'Sofia',
      'Henri',
      'Maria',
      'Oskar',
      'Eliise',
      'Maksim',
      'Linda',
      'Kaspar',
      'Mia',
    ],
    FI: [
      'Oliver',
      'Aino',
      'Elias',
      'Eevi',
      'Leo',
      'Emma',
      'Onni',
      'Sofia',
      'Noel',
      'Venla',
    ],
    FR: [
      'Gabriel',
      'Emma',
      'Raphaël',
      'Jade',
      'Léo',
      'Louise',
      'Louis',
      'Alice',
      'Lucas',
      'Chloé',
    ],
    DE: [
      'Leon',
      'Mia',
      'Finn',
      'Emma',
      'Noah',
      'Sofia',
      'Paul',
      'Lina',
      'Liam',
      'Hannah',
    ],
    GR: [
      'Georgios',
      'Maria',
      'Dimitrios',
      'Eleni',
      'Nikolaos',
      'Anna',
      'Ioannis',
      'Sofia',
      'Konstantinos',
      'Aikaterini',
    ],
    HU: [
      'Bence',
      'Hanna',
      'Máté',
      'Anna',
      'Levente',
      'Noémi',
      'Ádám',
      'Lili',
      'Dominik',
      'Zoé',
    ],
    IE: [
      'Jack',
      'Emily',
      'James',
      'Sophia',
      'Noah',
      'Grace',
      'Conor',
      'Amelia',
      'Daniel',
      'Ella',
    ],
    IT: [
      'Leonardo',
      'Sofia',
      'Francesco',
      'Aurora',
      'Lorenzo',
      'Giulia',
      'Matteo',
      'Emma',
      'Gabriele',
      'Ginevra',
    ],
    LV: [
      'Markuss',
      'Sofija',
      'Maksims',
      'Emīlija',
      'Artjoms',
      'Mia',
      'Roberts',
      'Elizabete',
      'Noah',
      'Anna',
    ],
    LU: [
      'Liam',
      'Emma',
      'Noah',
      'Léa',
      'Lucas',
      'Mila',
      'Adam',
      'Sofia',
      'Louis',
      'Clara',
    ],
    MK: [
      'Luka',
      'Ana',
      'David',
      'Elena',
      'Nikola',
      'Sara',
      'Marko',
      'Maria',
      'Aleksandar',
      'Iva',
    ],
    MT: [
      'Jake',
      'Ella',
      'Liam',
      'Amy',
      'Ben',
      'Emma',
      'Luke',
      'Maya',
      'Noah',
      'Emily',
    ],
    NL: [
      'Liam',
      'Emma',
      'Noah',
      'Julia',
      'Lucas',
      'Sophie',
      'Levi',
      'Mila',
      'Sem',
      'Zoe',
    ],
    NO: [
      'Oliver',
      'Emma',
      'Oscar',
      'Nora',
      'William',
      'Sofie',
      'Liam',
      'Olivia',
      'Henrik',
      'Mia',
    ],
    PL: [
      'Antoni',
      'Zuzanna',
      'Jakub',
      'Lena',
      'Szymon',
      'Maja',
      'Jan',
      'Amelia',
      'Kacper',
      'Alicja',
    ],
    PT: [
      'João',
      'Leonor',
      'Martim',
      'Matilde',
      'Tomás',
      'Beatriz',
      'Rodrigo',
      'Mariana',
      'Miguel',
      'Ana',
    ],
    RO: [
      'Matei',
      'Maria',
      'David',
      'Elena',
      'Andrei',
      'Ioana',
      'Lucas',
      'Andreea',
      'Alexandru',
      'Daria',
    ],
    RU: [
      'Artem',
      'Sofia',
      'Mikhail',
      'Maria',
      'Alexander',
      'Anna',
      'Dmitry',
      'Alina',
      'Ivan',
      'Daria',
    ],
    RS: [
      'Luka',
      'Sofija',
      'Stefan',
      'Jana',
      'Nikola',
      'Teodora',
      'Miloš',
      'Elena',
      'Filip',
      'Sara',
    ],
    SK: [
      'Jakub',
      'Ema',
      'Adam',
      'Sofia',
      'Samuel',
      'Nina',
      'Tomáš',
      'Viktória',
      'Filip',
      'Lucia',
    ],
    SI: [
      'Luka',
      'Eva',
      'Jan',
      'Zala',
      'Jakob',
      'Mia',
      'Žan',
      'Sara',
      'Filip',
      'Lana',
    ],
    ES: [
      'Lucas',
      'Lucía',
      'Hugo',
      'Sofía',
      'Martín',
      'María',
      'Mateo',
      'Paula',
      'David',
      'Emma',
    ],
    SE: [
      'Liam',
      'Ella',
      'William',
      'Alice',
      'Elias',
      'Lilly',
      'Noah',
      'Astrid',
      'Hugo',
      'Olivia',
    ],
    CH: [
      'Liam',
      'Emma',
      'Noah',
      'Mia',
      'Lucas',
      'Sophia',
      'Leon',
      'Lena',
      'Gabriel',
      'Emilia',
    ],
    UA: [
      'Oleksandr',
      'Sofiya',
      'Danylo',
      'Anastasia',
      'Maksym',
      'Maria',
      'Artem',
      'Anna',
      'Kyrylo',
      'Yana',
    ],
    GB: [
      'Oliver',
      'Olivia',
      'George',
      'Amelia',
      'Noah',
      'Isla',
      'Harry',
      'Ava',
      'Arthur',
      'Mia',
    ],
  },
  cities: {
    AL: ['Tirana', 'Durrës', 'Vlorë', 'Elbasan', 'Shkodër'],
    AD: [
      'Andorra la Vella',
      'Escaldes-Engordany',
      'Encamp',
      'Sant Julià de Lòria',
      'La Massana',
    ],
    AT: ['Vienna', 'Graz', 'Linz', 'Salzburg', 'Innsbruck'],
    BY: ['Minsk', 'Gomel', 'Mogilev', 'Vitebsk', 'Grodno'],
    BE: ['Brussels', 'Antwerp', 'Ghent', 'Charleroi', 'Liège'],
    BA: ['Sarajevo', 'Banja Luka', 'Tuzla', 'Zenica', 'Bijeljina'],
    BG: ['Sofia', 'Plovdiv', 'Varna', 'Burgas', 'Ruse'],
    HR: ['Zagreb', 'Split', 'Rijeka', 'Osijek', 'Zadar'],
    CY: ['Nicosia', 'Limassol', 'Larnaca', 'Paphos', 'Famagusta'],
    CZ: ['Prague', 'Brno', 'Ostrava', 'Plzeň', 'Liberec'],
    DK: ['Copenhagen', 'Aarhus', 'Odense', 'Aalborg', 'Frederiksberg'],
    EE: ['Tallinn', 'Tartu', 'Narva', 'Pärnu', 'Kohtla-Järve'],
    FI: ['Helsinki', 'Espoo', 'Tampere', 'Vantaa', 'Oulu'],
    FR: ['Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice'],
    DE: ['Berlin', 'Hamburg', 'Munich', 'Cologne', 'Frankfurt'],
    GR: ['Athens', 'Thessaloniki', 'Patras', 'Heraklion', 'Larissa'],
    HU: ['Budapest', 'Debrecen', 'Szeged', 'Miskolc', 'Pécs'],
    IS: ['Reykjavík', 'Kópavogur', 'Hafnarfjörður', 'Akureyri', 'Reykjanesbær'],
    IE: ['Dublin', 'Cork', 'Limerick', 'Galway', 'Waterford'],
    IT: ['Rome', 'Milan', 'Naples', 'Turin', 'Palermo'],
    XK: ['Pristina', 'Prizren', 'Ferizaj', 'Peja', 'Gjakova'],
    LV: ['Riga', 'Daugavpils', 'Liepāja', 'Jelgava', 'Jūrmala'],
    LI: ['Vaduz', 'Schaan', 'Balzers', 'Triesen', 'Eschen'],
    LU: [
      'Luxembourg City',
      'Esch-sur-Alzette',
      'Differdange',
      'Dudelange',
      'Ettelbruck',
    ],
    MK: ['Skopje', 'Bitola', 'Kumanovo', 'Prilep', 'Tetovo'],
    MT: ['Valletta', 'Birkirkara', 'Sliema', 'Mosta', 'Rabat'],
    MD: ['Chișinău', 'Tiraspol', 'Bălți', 'Bender', 'Rîbnița'],
    MC: [
      'Monaco-Ville',
      'Monte Carlo',
      'La Condamine',
      'Fontvieille',
      'Moneghetti',
    ],
    ME: ['Podgorica', 'Nikšić', 'Bijelo Polje', 'Cetinje', 'Bar'],
    NL: ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven'],
    NO: ['Oslo', 'Bergen', 'Trondheim', 'Stavanger', 'Drammen'],
    PL: ['Warsaw', 'Krakow', 'Lodz', 'Wroclaw', 'Poznan'],
    PT: ['Lisbon', 'Porto', 'Vila Nova de Gaia', 'Amadora', 'Braga'],
    RO: ['Bucharest', 'Cluj-Napoca', 'Timișoara', 'Iași', 'Constanța'],
    RU: ['Moscow', 'Saint Petersburg', 'Novosibirsk', 'Yekaterinburg', 'Kazan'],
    SM: [
      'San Marino',
      'Serravalle',
      'Borgo Maggiore',
      'Domagnano',
      'Fiorentino',
    ],
    RS: ['Belgrade', 'Novi Sad', 'Niš', 'Kragujevac', 'Subotica'],
    SK: ['Bratislava', 'Košice', 'Prešov', 'Žilina', 'Nitra'],
    SI: ['Ljubljana', 'Maribor', 'Celje', 'Kranj', 'Velenje'],
    ES: ['Madrid', 'Barcelona', 'Valencia', 'Seville', 'Zaragoza'],
    SE: ['Stockholm', 'Gothenburg', 'Malmö', 'Uppsala', 'Västerås'],
    CH: ['Zurich', 'Geneva', 'Basel', 'Lausanne', 'Bern'],
    UA: ['Kyiv', 'Kharkiv', 'Odessa', 'Dnipro', 'Donetsk'],
    VA: ['Vatican City'],
    US: [
      'New York',
      'Los Angeles',
      'Chicago',
      'Houston',
      'Phoenix',
      'Philadelphia',
      'San Antonio',
      'San Diego',
      'Dallas',
      'San Jose',
      'Austin',
      'Jacksonville',
      'Fort Worth',
      'Columbus',
      'Charlotte',
    ],
    CA: [
      'Toronto',
      'Montreal',
      'Vancouver',
      'Calgary',
      'Edmonton',
      'Ottawa',
      'Winnipeg',
      'Quebec City',
      'Hamilton',
      'Brampton',
    ],
    AU: [
      'Sydney',
      'Melbourne',
      'Brisbane',
      'Perth',
      'Adelaide',
      'Gold Coast',
      'Canberra',
    ],
    NZ: ['Auckland', 'Wellington', 'Christchurch', 'Hamilton', 'Tauranga'],
    GB: [
      'London',
      'Birmingham',
      'Leeds',
      'Glasgow',
      'Sheffield',
      'Bradford',
      'Manchester',
      'Edinburgh',
      'Liverpool',
      'Bristol',
    ],
  },
};
